<template>
    <v-dialog
        max-width="40rem"
        :fullscreen="xs && mobileFullscreen"
        :model-value="modelValue"
        :persistent="persistent"
        :aria-labelledby="titleId"
        @update:model-value="emit('update:modelValue', $event)"
    >
        <v-card>
            <v-toolbar
                :color="props.color"
                class="d-flex align-center"
                tag="div"
            >
                <v-icon
                    :icon="props.icon"
                    class="ml-4 mr-2"
                />
                <div
                    :id="titleId"
                    class="text-truncate"
                >
                    {{ props.title }}
                </div>
                <v-spacer />
                <slot name="toolbar" />
            </v-toolbar>
            <div
                v-if="$slots.banner"
                class="h-xs-0 pa-2 flex-grow-1"
            >
                <slot name="banner" />
            </div>
            <div class="overflow-auto h-xs-0 pa-2 flex-grow-1">
                <slot name="body" />
            </div>
            <v-card-actions
                class="pa-2"
                :class="`bg-${props.color}`"
            >
                <slot name="actions" />
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script lang="ts" setup>
import { useId } from 'vue';
import { useDisplay } from 'vuetify';

const { xs } = useDisplay();

const props = withDefaults(
    defineProps<{
        modelValue: boolean;
        icon: string;
        color: string;
        title: string;
        persistent?: boolean;
        mobileFullscreen?: boolean;
    }>(),
    {
        persistent: true,
        mobileFullscreen: true,
    },
);

const emit = defineEmits<{
    (event: 'update:modelValue', value: boolean): void;
}>();

const titleId = `BaseModal-${useId()}-title`;
</script>
